import Banner from "./AboutUs/Banner.jsx";
import FirstSection from "./AboutUs/FirstSection.jsx";
import MissionVission from "./AboutUs/MissionVission.jsx";
import CoreValues from "./AboutUs/CoreValues.jsx";

function AboutUsPage() {
  return (
    <>
      <Banner />
      <FirstSection />
      <MissionVission />
      <CoreValues />
    </>
  );
}

export default AboutUsPage;
